export default "__VITE_ASSET__C5Hg3b16__"